<template>
  <div :class="arabic ? 'arFont' : 'enFont'">
    <v-row class="align-center">
      <v-col cols="12" md="6">
        <v-switch
          @change="handleOnChange('language_started')"
          v-model="resource.language_started"
          :label="i18n.language_started"
          :disabled="resource.language_started"
        />
      </v-col>
      <v-col cols="12" md="6">
        <v-text-field
          outlined
          disabled
          dense
          v-model="resource.required_language_level"
          :label="i18n.required_language_level"
        />
      </v-col>
    </v-row>

    <v-divider></v-divider>

    <v-row v-if="resource.language_started && canSeeLevel('a1')">
      <v-col md="3" cols="12">
        <v-switch
          @change="handleOnChange('a_1_started')"
          outlined
          dense
          v-model="resource.a_1_started"
          :disabled="resource.a_1_started"
          :label="i18n.a_1_started"
        />
      </v-col>
      <v-col md="3" cols="12" v-if="resource.a_1_started">
        <CandidateDatePicker
          :date="resource.a_1_start_date"
          :label="i18n.a_1_start_date"
          field="a_1_start_date"
          @saveDate="saveDate"
        />
      </v-col>
      <v-col md="3" cols="12">
        <v-switch
          @change="handleOnChange('a_1_finished')"
          outlined
          dense
          v-model="resource.a_1_finished"
          :disabled="!resource.a_1_started || resource.a_1_finished"
          :label="i18n.a_1_finished"
        />
      </v-col>
      <v-col md="3" cols="12" v-if="resource.a_1_finished">
        <CandidateDatePicker
          :date="resource.a_1_finish_date"
          :label="i18n.a_1_finish_date"
          field="a_1_finish_date"
          @saveDate="saveDate"
        />
      </v-col>
    </v-row>

    <template v-if="resource.a_1_finished && !!resource.a_1_finish_date && canSeeLevel('a2')">
      <v-divider></v-divider>
      <v-row class="align-center">
        <v-col md="3" cols="12">
          <v-switch
            @change="handleOnChange('a_2_started')"
            outlined
            dense
            v-model="resource.a_2_started"
            :disabled="resource.a_2_started"
            :label="i18n.a_2_started"
          />
        </v-col>
        <v-col md="3" cols="12" v-if="resource.a_2_started">
          <CandidateDatePicker
            :date="resource.a_2_start_date"
            :label="i18n.a_2_start_date"
            field="a_2_start_date"
            @saveDate="saveDate"
          />
        </v-col>
        <v-col md="3" cols="12">
          <v-switch
            @change="handleOnChange('a_2_finished')"
            outlined
            dense
            v-model="resource.a_2_finished"
            :disabled="!resource.a_2_started || resource.a_2_finished"
            :label="i18n.a_2_finished"
          />
        </v-col>
        <v-col md="3" cols="12" v-if="resource.a_2_finished">
          <CandidateDatePicker
            :date="resource.a_2_finish_date"
            :label="i18n.a_2_finish_date"
            field="a_2_finish_date"
            @saveDate="saveDate"
          />
        </v-col>
      </v-row>
      <v-divider></v-divider>
    </template>

    <v-row class="align-center" v-if="resource.a_2_finished && !!resource.a_2_finish_date && canSeeLevel('b1')">
      <template>
        <v-col md="3" cols="12">
          <v-switch
            @change="handleOnChange('b_1_started')"
            outlined
            dense
            v-model="resource.b_1_started"
            :disabled="resource.b_1_started"
            :label="i18n.b_1_started"
          />
        </v-col>
        <v-col md="3" cols="12" v-if="resource.b_1_started">
          <CandidateDatePicker
            :date="resource.b_1_start_date"
            :label="i18n.b_1_start_date"
            field="b_1_start_date"
            @saveDate="saveDate"
          />
        </v-col>
        <v-col md="3" cols="12">
          <v-switch
            @change="handleOnChange('b_1_finished')"
            outlined
            dense
            v-model="resource.b_1_finished"
            :disabled="!resource.b_1_started || resource.b_1_finished"
            :label="i18n.b_1_finished"
          />
        </v-col>
        <v-col md="3" cols="12" v-if="resource.b_1_finished">
          <CandidateDatePicker
            :date="resource.b_1_finish_date"
            :label="i18n.b_1_finish_date"
            field="b_1_finish_date"
            @saveDate="saveDate"
          />
        </v-col>
      </template>
    </v-row>

    <template v-if="resource.b_1_finished && !!resource.b_1_finish_date && canSeeLevel('b2')">
      <v-divider></v-divider>
      <v-row class="align-center">
        <v-col md="3" cols="12">
          <v-switch
            @change="handleOnChange('b_2_started')"
            outlined
            dense
            v-model="resource.b_2_started"
            :disabled="resource.b_2_started"
            :label="i18n.b_2_started"
          />
        </v-col>
        <v-col md="3" cols="12" v-if="resource.b_2_started">
          <CandidateDatePicker
            :date="resource.b_2_start_date"
            :label="i18n.b_2_start_date"
            field="b_2_start_date"
            @saveDate="saveDate"
          />
        </v-col>
        <v-col md="3" cols="12">
          <v-switch
            @change="handleOnChange('b_2_finished')"
            outlined
            dense
            v-model="resource.b_2_finished"
            :disabled="!resource.b_2_started || resource.b_2_finished"
            :label="i18n.b_2_finished"
          />
        </v-col>
        <v-col md="3" cols="12" v-if="resource.b_2_finished">
          <CandidateDatePicker
            :date="resource.b_2_finish_date"
            :label="i18n.b_2_finish_date"
            field="b_2_finish_date"
            @saveDate="saveDate"
          />
        </v-col>
      </v-row>
    </template>
  </div>
</template>

<script>
import CandidateDatePicker from "./candidateDatePicker.vue";

export default {
  data() {
    const user = this.$store.state.user;
    console.log(user);
    return {
      resource: {
        language_started: Boolean(user.language_started),
        required_language_level: user.required_language_level,
        a_1_started: Boolean(user.a_1_started),
        a_1_start_date: user.a_1_start_date === "0000-00-00 00:00:00" ? null : user.a_1_start_date,
        a_1_finished: Boolean(user.a_1_finished),
        a_1_finish_date: user.a_1_finish_date === "0000-00-00 00:00:00" ? null : user.a_1_finish_date,
        a_1_passed: Boolean(user.a_1_passed),
        a_1_certificate: Boolean(user.a_1_certificate),
        a_2_started: Boolean(user.a_2_started),
        a_2_start_date: user.a_2_start_date === "0000-00-00 00:00:00" ? null : user.a_2_start_date,
        a_2_finished: Boolean(user.a_2_finished),
        a_2_finish_date: user.a_2_finish_date === "0000-00-00 00:00:00" ? null : user.a_2_finish_date,
        a_2_passed: Boolean(user.a_2_passed),
        a_2_certificate: Boolean(user.a_2_certificate),
        b_1_started: Boolean(user.b_1_started),
        b_1_start_date: user.b_1_start_date === "0000-00-00 00:00:00" ? null : user.b_1_start_date,
        b_1_finished: Boolean(user.b_1_finished),
        b_1_finish_date: user.b_1_finish_date === "0000-00-00 00:00:00" ? null : user.b_1_finish_date,
        b_1_passed: Boolean(user.b_1_passed),
        b_1_certificate: Boolean(user.b_1_certificate),
        b_2_started: Boolean(user.b_2_started),
        b_2_start_date: user.b_2_start_date === "0000-00-00 00:00:00" ? null : user.b_2_start_date,
        b_2_finished: Boolean(user.b_2_finished),
        b_2_finish_date: user.b_2_finish_date === "0000-00-00 00:00:00" ? null : user.b_2_finish_date,
        b_2_passed: Boolean(user.b_2_passed),
        b_2_certificate: Boolean(user.b_2_certificate),
        b_1_document_id: Boolean(user.b_1_document_id),
        b_2_document_id: Boolean(user.b_2_document_id),
      },
      menu: false,
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    language() {
      return this.$store.state.language;
    },
    i18n() {
      return this.$store.state.i18n[this.$store.state.language];
    },
    arabic() {
      if (this.$store.state.language == "ar") return true;
    },
  },
  methods: {
    canSeeLevel(level) {
      return this.resource.required_language_level >= level;
    },
    async handleOnChange(field, data = null) {
      const value = {};
      if (data) {
        value[field] = data;
      } else {
        value[field] = this.resource[field];
      }
      await this.$store.dispatch("putResource", { resource: "/language-updates", value });
      await this.$store.dispatch("getUser");
    },
    saveDate(date, field) {
      this.handleOnChange(field, date);
    },
  },
  components: { CandidateDatePicker },
};
</script>
